// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__iEvRU","colMaxWidth":"Table_colMaxWidth__1xMNn"};